import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">McMahon · Portfolio & Business Showcase</p>
        <h1>Elevate Your Vision.</h1>
        <p className="lede">
          Discover a curated collection of my professional work and business endeavors. 
          Explore how I can help bring your ideas to life with creativity and expertise.
        </p>
        <div className="cta-row">
          <a href="#portfolio" target="_self">
            View My Work
          </a>
          <a href="#contact" target="_self" className="secondary">
            Get in Touch
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Showcase Your Talent</h2>
          <p>
            Browse through a diverse portfolio that highlights my skills and projects, tailored to meet various needs.
          </p>
        </article>
        <article>
          <h2>Collaborate with Confidence</h2>
          <p>
            Let's work together to turn your vision into reality. I offer personalized solutions that align with your goals.
          </p>
        </article>
        <article>
          <h2>Stay Connected</h2>
          <p>
            Join my network for updates on new projects, insights, and opportunities to collaborate.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;